import { useMemo } from "react";

const GeneratedLinkStep = ({
  linkData,
  user,
  country,
  tokenData,
  environment,
}) => {
  const generatedLink = useMemo(() => {
    if (
      !linkData.cocoLinktype ||
      !linkData.customerId ||
      !linkData.sourceSystem
    )
      return "Please fill all required fields to generate the link";

    const {
      salutation,
      title,
      first_name,
      last_name,
      controllerCode,
      language,
    } = user;

    const division = controllerCode?.toUpperCase()?.split("_")[1] || "";
    const countryCode = country?.value || "";
    const loggedInUserCWID = tokenData?.["https://bayer.com/cwid"] || "";

    const params = {
      CustomerID: linkData.customerId || "",
      Division: division,
      CountryCode: countryCode,
      Language: language || "en",
      FirstName: first_name || "",
      LastName: last_name || "",
      EmailInput1: linkData.emailOne || "",
      EmailInput2: linkData.emailTwo || "",
      LoggedInUserCWID: loggedInUserCWID,
      SourceSystem: linkData.sourceSystem?.toUpperCase() || "",
      Title: title || "",
      Salutation: salutation || "",
    };

    // Remove null values
    Object.keys(params).forEach((key) => {
      if (params[key] === null) delete params[key];
    });

    const queryString = new URLSearchParams(params).toString();

    if (linkData.cocoLinktype === "cocoapp") {
      return `CocoTMQA://com.bayer.ph.cocotm/?${queryString}`;
    } else if (linkData.cocoLinktype === "cocoonline") {
      let baseUrl =
        "https://documents.eu.development.truman.bayer.com/ui/coco/";
      if (environment.includes("staging"))
        baseUrl = "https://documents.eu.staging.truman.bayer.com/ui/coco/";
      // Add more environments if needed
      return `${baseUrl}?${queryString}`;
    }

    return "Invalid link type";
  }, [linkData, user, country, tokenData, environment]);
  return (
    <div className="row" style={{ marginBottom: 10 }}>
      <h5 className="fs-6">Step 3: Test Generated Link</h5>
      <div className="col-md-12">
        <p>
          {generatedLink && (
            <a
              href={generatedLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{ wordBreak: "break-all" }}
            >
              {generatedLink}
            </a>
          )}
        </p>
      </div>
    </div>
  );
};

export default GeneratedLinkStep;
